/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { z, ZodSchema } from 'zod';
import { OPERATION } from './enums.js';

var PrimitiveSchema = z.union([z.number(), z.string(), z["boolean"]()]);
var PrimitiveArraySchema = z.array(z.union([z.number(), z.string(), z["boolean"]()]));
var BetweenSchema = z.object({
  min: PrimitiveSchema,
  max: PrimitiveSchema
});
var LastYearsSchema = z.object({
  years: z.number().positive()
});
var ExistsSchema = z.object({
  schema: z.any().refine(function (val) {
    return val instanceof ZodSchema;
  }, {
    message: 'Value must be a Zod schema'
  })
});
var BaseOperationsValueSchema = z.union([z.object({
  operator: z.literal(OPERATION.EQUALS),
  value: PrimitiveSchema
}), z.object({
  operator: z.literal(OPERATION.NOT_EQUALS),
  value: PrimitiveSchema
}), z.object({
  operator: z.literal(OPERATION.BETWEEN),
  value: BetweenSchema
}),
// Add other operator-specific schemas here
z.object({
  operator: z.literal(OPERATION.GT),
  value: PrimitiveSchema
}), z.object({
  operator: z.literal(OPERATION.LT),
  value: PrimitiveSchema
}), z.object({
  operator: z.literal(OPERATION.GTE),
  value: PrimitiveSchema
}), z.object({
  operator: z.literal(OPERATION.LTE),
  value: PrimitiveSchema
}), z.object({
  operator: z.literal(OPERATION.IN),
  value: PrimitiveArraySchema
}), z.object({
  operator: z.literal(OPERATION.NOT_IN),
  value: PrimitiveArraySchema
})]);
var AmlCheckSchema = z.object({
  childWorkflowName: z.string()
}).and(BaseOperationsValueSchema);
var AmlCheckV2Schema = BaseOperationsValueSchema;
var BankAccountVerificationSchema = z.object({
  operator: z.literal(OPERATION.BANK_ACCOUNT_VERIFICATION)
});
var IdvCheckSchema = z.object({
  childWorkflowName: z.string()
});
var CompanySanctionsCategoriesSchema = z.object({
  threshold: z.number().optional(),
  category: z.union([z.literal('Adverse Media'), z.string()])
});
var UboMismatchSchema = z.object({
  operator: z.literal(OPERATION.UBO_MISMATCH)
});

export { AmlCheckSchema, AmlCheckV2Schema, BankAccountVerificationSchema, BaseOperationsValueSchema, BetweenSchema, CompanySanctionsCategoriesSchema, ExistsSchema, IdvCheckSchema, LastYearsSchema, PrimitiveArraySchema, PrimitiveSchema, UboMismatchSchema };
//# sourceMappingURL=schemas.js.map
